import { Button } from "@/components/ui/button";
import {
  Home,
  // FilePen,
  // Settings,
  ChevronRight,
  Plus,
  MoveLeft,
  // Trash2,
} from "lucide-react";
import { useNotes, Note } from "@/providers/note-provider";
import { useTranslation } from "@/providers/language-provider";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "@/components/ui/dropdown-menu";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from "@/components/ui/breadcrumb";
import { useEffect, useMemo, useState } from "react";

const localeText = {
  en: {
    Home: "Home",
    CreateNote: "New Note",
    EditNote: "Edit Note",
    DeleteNote: "Delete Note",
  },
  ko: {
    Home: "홈",
    CreateNote: "새 노트",
    EditNote: "노트 수정",
    DeleteNote: "노트 삭제",
  },
} as const;

function getNotePath(currentNote: Note, notes: Note[]): Note[] {
  const path: Note[] = [];
  let current = currentNote;

  while (current) {
    path.push(current);
    if (!current.parent) break;
    const parent = notes.find((note) => note._id === current.parent);
    if (!parent) break;
    current = parent;
  }

  return path.reverse();
}

export function NoteMenu() {
  const { language } = useTranslation();
  const {
    notes,
    createNewNote,
    // selectNote,
    activeParent,
    selectParent,
    // deleteNote,
  } = useNotes();

  const [openPath, setOpenPath] = useState<Note[]>([]);

  useEffect(() => {
    if (activeParent) {
      const notePath = getNotePath(activeParent, notes);
      setOpenPath(notePath);
    } else {
      setOpenPath([]);
    }
  }, [notes, activeParent]);

  const text = useMemo(() => {
    return localeText[language as keyof typeof localeText] ?? localeText["en"];
  }, [language]);

  function goHome() {
    selectParent(null);
  }

  function goParent() {
    if (activeParent) {
      selectParent(activeParent.parent);
    }
  }

  function createNote() {
    if (activeParent) {
      createNewNote(activeParent._id);
    } else {
      createNewNote();
    }
  }

  const isHome = !activeParent;

  return (
    <div className="flex justify-between items-center p-2">
      <div className="flex items-center flex-1 min-w-0">
        {!isHome && (
          <Button size="icon" variant="ghost" onClick={goParent}>
            <MoveLeft className="h-4 w-4" />
          </Button>
        )}

        <Breadcrumb>
          <BreadcrumbList className="flex-wrap">
            <BreadcrumbItem>
              <BreadcrumbLink
                onClick={goHome}
                className={`cursor-pointer flex items-center gap-1 ${isHome ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}
              >
                <Home className="h-4 w-4" />
                <span>{text.Home}</span>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {openPath.map((note: Note, index: number) => {
              const isLast = index === openPath.length - 1;
              return (
                <BreadcrumbItem key={note._id}>
                  <span className="text-muted-foreground">
                    <ChevronRight className="h-4 w-4" />
                  </span>
                  <BreadcrumbLink
                    onClick={() => selectParent(note)}
                    className={`cursor-pointer truncate max-w-[150px] ${isLast ? "text-primary font-medium" : "text-muted-foreground hover:text-foreground"}`}
                  >
                    {note.title}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <div className="flex items-center gap-1">
        <Button size="icon" variant="ghost" onClick={createNote}>
          <Plus className="h-4 w-4" />
        </Button>
        {/* <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="icon" variant="ghost">
              <Settings className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="left" align="start">
            <DropdownMenuItem
              onClick={() => {
                if (activeParent) {
                  selectNote(activeParent);
                }
              }}
              disabled={!activeParent}
            >
              <FilePen className="h-4 w-4 mr-2" />
              {text.EditNote}
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                if (activeParent) {
                  deleteNote(activeParent);
                }
              }}
              disabled={!activeParent}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              {text.DeleteNote}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu> */}
      </div>
    </div>
  );
}
